module.exports = __webpack_public_path__ + "static/media/close_lightbox.86dcc549.svg";